


















































































import { Component, Vue } from "vue-property-decorator";
import MonthSelectorVue from "../components/MonthSelector.vue";
import { mapGetters } from "vuex";
// 13 07准则 引入ts 的表格数据
import incomeData, { Income } from "@/data/incomeData";
import AccountingSystem from "@/data/AccountingSystem";
import version from "@/version";

@Component({
	...mapGetters(["accountBook"]),
	components: {
		"month-selector": MonthSelectorVue,
	},
})
export default class IncomeStatement extends Vue {
	accountSystem =
		this.$store.state.accountBook.accountingSystem === AccountingSystem.thirteenRule;

	// 07 13 准则表格数据
	dataList: Income[] = [];
	//改变时间
	period: String[] = []; // 日期
	changeDate(date: string[]) {
		this.period = date;
		this.fetchData();
		this.cashover();
	}
	mounted() {
		this.dataList = incomeData.getData(this.$store.state.accountBook);
	}

	yearCashs: string[] = [];
	monthCashs: string[] = [];
	lastYearMonthCashs: string | null = null;
	// 获取表格数据
	fetchData() {
		Vue.axios
			.post(`profits/find`, {
				accountBookId: this.$store.state.accountBook.id,
				endPeriod: this.period,
			})
			.then((res) => {
				this.yearCashs = res.data.yearCashs;
				this.monthCashs = res.data.monthCashs;
				this.lastYearMonthCashs = res.data.lastYearMonthCashs;
				for (let i = 0; i < this.dataList.length; i++) {
					this.dataList[i].yearCash = this.yearCashs[i];
					this.dataList[i].monthCash = this.monthCashs[i];
					if (this.lastYearMonthCashs != null) {
						this.dataList[i].lastYearMonthCash =
							this.lastYearMonthCashs[i];
					}
				}
			});
	}

	// 下拉收起
	openClose(el: any, startNum: number, endNum: number, status: boolean) {
		let elTrs: any = document.querySelectorAll("#income-tbody tr");
		if (status == true) {
			for (var i = startNum; i <= endNum - 1; i++) {
				elTrs[i].style.display = "none";
			}
			el.currentTarget.setAttribute(
				"class",
				"el-icon-arrow-up hover-main-color-text"
			);
			this.dataList[startNum - 1].openStatus = false;
			this.$forceUpdate();
		} else {
			for (var i = startNum; i <= endNum - 1; i++) {
				elTrs[i].style.display = "";
			}
			el.currentTarget.setAttribute("class", "el-icon-arrow-down");
			this.dataList[startNum - 1].openStatus = true;
			this.$forceUpdate();
		}
	}

	// 获取是否有未结转
	cashoverTip: boolean = false;
	message: string = "";
	cashover() {
		Vue.axios
			.post(`profits/getInfo`, {
				accountBookId: this.$store.state.accountBook.id,
				endPeriod: this.period,
			})
			.then((res) => {
				if (res.data[0].bubble != null) {
					this.cashoverTip = true;
					this.message = res.data[0].message;
				} else {
					this.cashoverTip = false;
				}
			});
	}
	//
	msgAlert() {
		this.$msgbox({
			message: this.message,
			title: "温馨提示",
			confirmButtonText: "确定",
		});
	}

	downLoad() {
		this.$utils.sendToElectron("download", `${Vue.axios.defaults.baseURL}export/income?accountBookId=${this.$store.state.accountBook.id}&startPeriod=${this.period}&endPeriod=${this.period}&version=${version}&token=${this.$store.state.account.token}`)
	}
}
